import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import Accordion from "../../components/Accordion";
import AccordionBootomGap from "../../components/AccordionBottomGap";
import useNavigation from "../../hooks/useNavigation";
import { useStores } from "../../models";
import { hidePhoneNumber } from "../../utils";
import { version } from "../../version";
import useGlobalTheme from "../../hooks/useGlobalTheme";

const Body = styled.div`
  height: calc(100% - ${headerHeight});
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #f7f8ff;
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

const LogoutButton = styled.button`
  flex-shrink: 0;
  height: 40px;
  margin: 16px 32px 24px;
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: 14px;
  cursor: pointer;
`;

const SettingDomain = () => {
  const theme = useGlobalTheme();
  const { navigate } = useNavigation();
  const { eventStore, walletStore } = useStores();
  const phone = walletStore.phone;

  useEffect(() => {
    walletStore.getWalletInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrap>
      <PageHeader title="设置" />
      <Body>
        <Content>
          <Accordion
            title="手机号"
            onItemPress={() => navigate("PhoneBinding")}
          >
            {phone ? `+86 ${hidePhoneNumber(phone)}` : "未绑定"}
          </Accordion>
          <Accordion title={`版本更新(${version})`}>当前版本</Accordion>
          <AccordionBootomGap />
        </Content>
        <LogoutButton
          type="button"
          style={{ background: theme.colors.primary }}
          onClick={() => eventStore.publicLogout()}
        >
          退出登录
        </LogoutButton>
      </Body>
    </PageWrap>
  );
};

export default observer(SettingDomain);
